
export const nocStatus = {
    locked: "locked",
    not_submitted: "not_submitted",
    submitted: "submitted",
    verified: "verified",
    rejected: "rejected"
} as const

